import { useState } from "react";
import { Tabs, Tab } from "react-bootstrap";
import { EDITOR_VIEW_NAME } from "../../core/constants";
import { store } from "../../core/state";
import { getErrorCode, getStartCode } from "../../features/coderunner";
import { evaluateResult } from "../../features/evaluate";
import { AdditionalInfoCollapsible } from "../accordions/AdditionalInfoCollapsible";
import { AppIFrame } from "../AppIFrame";
import { CodeControlsMenu } from "../CodeControlsMenu";
import { CodeEntryHelper } from "../codeentryhelper/CodeEntryHelper";
import { QuestionModal } from "../modals/QuestionModal";
import { ProjectEditor } from "../ProjectEditor";

export const CodeProjectQuestion = (props : { project, rightAnswer, wrongAnswer, evaluated }) => {
  const [editorState] = store.useState(EDITOR_VIEW_NAME);
  const [key, setKey] = useState('editor');

  const runApp = () => {
    setKey('app')
    evalCode();
  }

  const evalCode = () => {
    const finished = evaluateResult(editorState.project.eval)
    if (finished) {
      props.rightAnswer();
    } else {
      props.wrongAnswer();
    }
  }

  const executeCode = editorState?.data?.executionCode || getStartCode(editorState);
  const errorCode = getErrorCode(editorState);
  const timeStamp = editorState?.data?.time;

  const view = (
    <>
      <AppIFrame doc={errorCode || executeCode}
                 timeStamp={timeStamp}
                 classNames="ratio ratio-16x9"
                 fullScreen={false}
                 landscape={false}
                 muteSound={false}
                 hasAppBorder={true} />
    </>
  );

  const hasCodeEntryHelper = props.project.entries;
  const codeEntryHelper = <CodeEntryHelper chars={hasCodeEntryHelper} open={true} link={null} />;

  const hasSolutionCode = editorState.data?.projectContent?.solutionCode;
  const solutionCode = `<code>${editorState.data?.projectContent?.solutionCode}</code>`;
  const solutionInfo = <AdditionalInfoCollapsible text={"Lösung anzeigen"} detail={solutionCode} />

  return (<>
    <QuestionModal />
    <h3 className="text-center mb-5">{props.project.question}</h3>
    <div className="d-grid gap-2">
      <Tabs id="responsiveTabs" activeKey={key} onSelect={(k) => setKey(k)}>
        <Tab title="Editor" eventKey="editor" >
          <ProjectEditor />
        </Tab>
        <Tab title="App" eventKey="app" >
          {view}
        </Tab>
      </Tabs>
      <span><CodeControlsMenu runCode={runApp}/> {codeEntryHelper}</span>
      { hasSolutionCode && solutionInfo }
    </div>
  </>);

}
